import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../utils/constant";

// Async thunk to fetch bills
export const fetchBills = createAsyncThunk("bills/fetchBills", async (id, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/bills/${id}`);
    return response.data; // Assume API returns an array of bills
  } catch (error) {
    return rejectWithValue(error.response?.data || "Failed to fetch bills");
  }
});

// Async thunk to create a new bill
export const createBill = createAsyncThunk("bills/createBill", async (billData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/bills`, billData);
    return response.data; // Assume API returns the created bill
  } catch (error) {
    return rejectWithValue(error.response?.data || "Failed to create bill");
  }
});

// Async thunk to update a bill
export const updateBill = createAsyncThunk("bills/updateBill", async ({ id, updatedData }, { rejectWithValue }) => {
  try {
    const response = await axios.put(`${API_URL}/bills/${id}`, updatedData);
    return response.data; // Assume API returns the updated bill
  } catch (error) {
    return rejectWithValue(error.response?.data || "Failed to update bill");
  }
});

// Async thunk to delete a bill
export const deleteBill = createAsyncThunk("bills/deleteBill", async (id, { rejectWithValue }) => {
  try {
    await axios.delete(`${API_URL}/bills/${id}`);
    return id; // Return the deleted bill ID
  } catch (error) {
    return rejectWithValue(error.response?.data || "Failed to delete bill");
  }
});

// Bills slice
const billsSlice = createSlice({
  name: "bills",
  initialState: {
    bills: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBills.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBills.fulfilled, (state, action) => {
        state.loading = false;
        state.bills = action.payload;
      })
      .addCase(fetchBills.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createBill.fulfilled, (state, action) => {
        state.bills.push(action.payload.bill);
      })
      .addCase(updateBill.fulfilled, (state, action) => {
        const index = state.bills.findIndex((bill) => bill.id === action.payload.id);
        if (index !== -1) {
          state.bills[index] = action.payload;
        }
      })
      .addCase(deleteBill.fulfilled, (state, action) => {
        state.bills = state.bills.filter((bill) => bill.id !== action.payload);
      });
  },
});

export default billsSlice.reducer;
